// extracted by mini-css-extract-plugin
export default {"page__title":"Dashboard_page__title__WYdqK"};